/**
 * Environment tag in the browser tab title.
 *
 * The SPA sets document.title in several places (venue-app-shell, admin pages),
 * so instead of editing each, this watches the <title> and prefixes whatever it
 * becomes with the current environment, so staging and prod tabs are instantly
 * distinguishable. PROD is deliberately left clean (no prefix): real customers
 * see the tab, and "[PROD]" would look unprofessional. The absence of a prefix
 * IS the prod signal.
 *
 *   staging host (*.aws-staging.…) → "[STAGING] <title>"
 *   local dev (localhost/127/.local) → "[DEV] <title>"
 *   everything else (prod)          → unchanged
 */
function envPrefix(hostname: string): string {
  if (hostname.includes("aws-staging")) return "[STAGING] ";
  if (hostname === "localhost" || hostname.startsWith("127.") || hostname.endsWith(".local")) {
    return "[DEV] ";
  }
  return ""; // prod, clean title
}

export function initEnvTitle(): void {
  if (typeof document === "undefined") return;
  const prefix = envPrefix(window.location.hostname);
  if (!prefix) return; // prod: nothing to do

  let titleEl = document.querySelector("title");
  if (!titleEl) titleEl = document.head.appendChild(document.createElement("title"));

  const apply = () => {
    if (!document.title.startsWith(prefix)) document.title = prefix + document.title;
  };
  apply();
  // Re-apply whenever the SPA changes the title (guard in apply() prevents a loop).
  new MutationObserver(apply).observe(titleEl, {
    childList: true,
    characterData: true,
    subtree: true,
  });
}
